import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../Shared/Process/Process/WizardLinter";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { PaperLess } from "../../../Common/PaymentsIn/PaperLess";
import { AdviceType } from "../../../Common/WrapperSelection/AdviceType";
import { EWizardLinterHelper } from "../../Resource/EWizardLinterHelper";

interface IAdviceSectionProps extends IProcessComponentProps {
    isCreateNew: boolean;
}

interface IAdviceSectionState {}

export class AdviceSection extends ProcessComponent<IAdviceSectionProps, IAdviceSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getBlockStatus(): EWizardLinterStatus {
        const { data } = this.props;
        const complete =
            data &&
            data.AccountAdviceType > 0 &&
            data.AccountName != null &&
            data.AccountName.Full != null &&
            data.AdviceGiven != null;
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    public render(): JSX.Element {
        const { data, isCreateNew } = this.props;
        return (
            <WizardLinter status={this.getBlockStatus()}>
                <AdviceType
                    onRef={(ref) => this.appendChild(ref)}
                    data={this.props.data}
                    onChange={
                        !isCreateNew
                            ? () => {}
                            : (changes) => {
                                  this.props.onChange(changes);
                              }
                    }
                    readOnly={!isCreateNew}
                />
                <PaperLess
                    onRef={(ref) => this.appendChild(ref)}
                    data={this.props.data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    readOnly={!isCreateNew}
                />
                <FinancialAdvice
                    onRef={(ref) => this.appendChild(ref)}
                    data={this.props.data}
                    onChange={(changes) => {
                        this.props.onChange(changes);
                    }}
                    readonly={!isCreateNew}
                />
            </WizardLinter>
        );
    }
}
